import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Termeni from "@/pages/legal/Termeni";
import Confidentialitate from "@/pages/legal/Confidentialitate";
import Cookies from "@/pages/legal/Cookies";
import Precontractuale from "@/pages/legal/Precontractuale";
import CookieConsent from "@/components/site/CookieConsent";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/termeni-si-conditii" element={<Termeni />} />
                    <Route path="/politica-de-confidentialitate" element={<Confidentialitate />} />
                    <Route path="/politica-cookies" element={<Cookies />} />
                    <Route path="/informatii-precontractuale" element={<Precontractuale />} />
                </Routes>
                <CookieConsent />
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
